export const HOME = {
  emergentLink: "emergent-link",
};

export const TID = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    linkFeatures: "nav-link-features",
    linkChannels: "nav-link-channels",
    linkPricing: "nav-link-pricing",
    linkFaq: "nav-link-faq",
    ctaSubscribe: "nav-cta-subscribe",
  },
  hero: {
    root: "hero-section",
    ctaSubscribe: "hero-cta-subscribe",
    ctaLearn: "hero-cta-learn",
  },
  features: {
    root: "features-section",
    card: (i) => `feature-card-${i}`,
  },
  regions: {
    root: "regions-section",
    card: (key) => `region-card-${key}`,
    arabicTeaser: "region-arabic-teaser",
  },
  pricing: {
    root: "pricing-section",
    card: (id) => `pricing-card-${id}`,
    cta: (id) => `pricing-cta-${id}`,
  },
  faq: {
    root: "faq-section",
    item: (i) => `faq-item-${i}`,
  },
  signup: {
    root: "signup-section",
    form: "signup-form",
    name: "signup-input-name",
    email: "signup-input-email",
    plan: "signup-input-plan",
    message: "signup-input-message",
    submit: "signup-submit",
    success: "signup-success",
    error: "signup-error",
  },
  footer: {
    root: "site-footer",
  },
};
